import { Link } from 'react-router-dom';
import { Construction } from 'lucide-react';
import { useTranslation } from '../../application/hooks/useTranslation';
import { Button } from '../components/ui/Button';

/**
 * Route-guard target for the four held features (knowledge-tree §6).
 * Shows WHY the feature is held instead of a broken page.
 */
export default function PendingContractDecision() {
  const { t } = useTranslation();
  return (
    <div className="state-box" data-testid="pending-contract" style={{ textAlign: 'left' }}>
      <Construction size={28} aria-hidden />
      <h1 style={{ fontSize: 'var(--font-size-lg)' }}>{t('held.title')}</h1>
      <p>{t('held.body')}</p>
      <ul className="held-list">
        <li>{t('held.w08')}</li>
        <li>{t('held.kyc')}</li>
      </ul>
      <p className="muted">{t('held.note')}</p>
      <Link to="/">
        <Button variant="secondary">{t('held.back')}</Button>
      </Link>
    </div>
  );
}
